import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';


import Home from './routes/Home';
import MadFactory from './routes/MadFactory';
import MFDemo from './routes/MFDemo';
import ToU from './routes/ToU';
import CubeFit from './routes/CubeFit';
import Privacy from './routes/Privacy';
import Feedback from './routes/Feedback';



function App() {
    return (
        <div className="App">
            <Router>
                <Switch>
                    <Route exact path='/' component={Home}/>
                    <Route path='/madFactory' exact component={MadFactory}/>
                    <Route path='/tou' component={ToU}/>
                    <Route path='/cubeFit' component={CubeFit}/>
                    <Route path='/privacy' component={Privacy}/>
                    <Route path='/madFactory/demo' exact component={MFDemo}/>
                    {/*<Route path='/feedback/:type' exact component={Feedback}/>*/}
                </Switch>
            </Router>
        </div>
    );
}



export default App;
